import Cookies from 'js-cookie'

const KEY_TOKEN = 'mofang-token'

export function getToken() {
    return Cookies.get(KEY_TOKEN)
}

export function setToken(token) {
    Cookies.set(KEY_TOKEN, token)
}
